import React from 'react';

import { If } from 'utils';
import { UiKit } from 'components';
import { FeatureContainer } from '../../components';
import * as ShippingConfig from './ShippingConfig';
import * as PreferredCarrier from './PreferredCarrier';
import { useFTUWizard } from '../../context';
import { IS_ALL_SSR } from 'dictionary';

export default function Form() {
  const { onGotoNext } = useFTUWizard();

  const shippingConfig = ShippingConfig.useShippingConfig();
  const preferredCarrier = PreferredCarrier.usePreferredCarrier();

  const configs = [shippingConfig, preferredCarrier];
  const isLoading = configs.some(config => config.isLoading);
  const isProcessing = configs.some(config => config.isProcessing);

  const onSave = () => {
    const isValid = configs.every(config => config.onValidate(config.data));
    if (!isValid) return;

    const apis = configs.reduce((acc, config) => {
      if (config.isDirty) acc.push(config.onSave());
      return acc;
    }, []);

    if (!apis.length) return onGotoNext();

    Promise.all(apis)
      .then(() => onGotoNext())
      .catch(error => onGotoNext(error));
  };

  return (
    <ShippingConfig.Loader isLoading={isLoading}>
      <UiKit.Flex direction="column" gap={120}>
        <ShippingConfig.Form isDisabled={isProcessing} />
        <If test={!IS_ALL_SSR}>
          <FeatureContainer
            title="How should the carrier and services be determined?"
            subtitle="Configure which carriers and services are used for return shipments."
            gap={24}
          >
            <PreferredCarrier.Loader>
              <PreferredCarrier.Form isDisabled={isProcessing} />
            </PreferredCarrier.Loader>
          </FeatureContainer>
        </If>
      </UiKit.Flex>
      <UiKit.Sheet.ActionsPortal>
        <UiKit.Button size="lg" processing={isProcessing} onClick={onSave}>
          Continue
        </UiKit.Button>
      </UiKit.Sheet.ActionsPortal>
    </ShippingConfig.Loader>
  );
}
